<template>
  <v-layout>
    <v-flex>
      <v-layout wrap align-center>
        <h1 class="headline">Taxes</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              fab
              dark
              color="primary"
              @click="createItem"
              class="ma-2"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Tax</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="taxes.edges"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
          <template v-slot:item.validFrom="{ item }">
            {{ item.node.validFrom | formatDate }}
          </template>
          <template v-slot:item.validTo="{ item }">
            {{ item.node.validTo | formatDate }}
          </template>
          <template v-slot:item.isAccommodation="{ item }">
            <v-checkbox
              v-model="item.node.isAccommodation"
              hide-details
              :disabled="true"
              class="pa-0 ma-0"
            ></v-checkbox>
          </template>
          <template v-slot:item.isActivity="{ item }">
            <v-layout align-center justify-center>
              <v-checkbox
                v-model="item.node.isActivity"
                hide-details
                :disabled="true"
                class="pa-0 ma-0"
              ></v-checkbox>
            </v-layout>
          </template>
          <template v-slot:item.isTransport="{ item }">
            <v-layout align-center justify-center>
              <v-checkbox
                v-model="item.node.isTransport"
                hide-details
                :disabled="true"
                class="pa-0 ma-0"
              ></v-checkbox>
            </v-layout>
          </template>
          <template v-slot:item.isTravel="{ item }">
            <v-layout align-center justify-center>
              <v-checkbox
                v-model="item.node.isTravel"
                hide-details
                :disabled="true"
                class="pa-0 ma-0"
              ></v-checkbox>
            </v-layout>
          </template>
          <template v-slot:item.isOther="{ item }">
            <v-layout align-center justify-center>
              <v-checkbox
                v-model="item.node.isOther"
                hide-details
                :disabled="true"
                class="pa-0 ma-0"
              ></v-checkbox>
            </v-layout>
          </template>
          <template v-slot:item.isTransfer="{ item }">
            <v-layout align-center justify-center>
              <v-checkbox
                v-model="item.node.isTransfer"
                hide-details
                :disabled="true"
                class="pa-0 ma-0"
              ></v-checkbox>
            </v-layout>
          </template>
        </v-data-table>
      </v-card>
      <v-card>
        <v-dialog v-model="taxEditorDialog" persistent width="600">
          <v-card>
            <tax-editor
              :tax="selectedTax"
              :doSaveTax="doSaveTax"
              :taxEditorDialog="taxEditorDialog"
              @saved="onSaved($event)"
              @onResetSave="onResetSave"
            ></tax-editor>
            <v-card-actions class="grey lighten-4">
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
              <v-btn color="primary" @click="onSaveTax">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  TAXES_QUERY,
  TAX_DELETE_MUTATION,
} from "../../../../constants/graphql";
import DefaultListActions from "../../shared/DefaultListActions";
import TaxEditor from "./TaxEditor";
import { pagingOptions } from "../../../../helpers/index";

export default {
  name: "TaxesList",

  components: {
    DefaultListActions,
    TaxEditor,
  },

  data() {
    return {
      pagingOptions,
      search: "",
      taxes: {},
      selectedTax: {},
      doSaveTax: false,
      taxEditorDialog: false,
      headers: [
        {
          text: "Description",
          value: "node.description",
          name: "description",
        },
        {
          text: "From",
          value: "validFrom",
          name: "validFrom",
        },
        {
          text: "To",
          value: "validTo",
          name: "validTo",
        },
        {
          text: "Code",
          value: "node.code",
          name: "code",
        },
        {
          text: "%",
          value: "node.percentage",
          name: "percentage",
        },
        {
          text: "Accommodation",
          value: "isAccommodation",
          name: "accommodation",
        },
        {
          text: "Activity",
          value: "isActivity",
          name: "activity",
        },
        {
          text: "Transport",
          value: "isTransport",
          name: "transport",
        },
        {
          text: "Travel",
          value: "isTravel",
          name: "travel",
        },
        {
          text: "Other",
          value: "isOther",
          name: "other",
        },
        {
          text: "Transfer",
          value: "isTransfer",
          name: "transfer",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    createItem() {
      this.selectedTax = {};
      this.taxEditorDialog = true;
    },
    editItem(item) {
      this.selectedTax = item.node;
      this.taxEditorDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: TAX_DELETE_MUTATION,
          variables: {
            taxId: item.node.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", { msg: "Tax removed." });
      if (this.$apollo.queries.taxes != null) {
        this.$apollo.queries.taxes.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
    },
    onSaved(context) {
      if (this.$apollo.queries.taxes != null) {
        this.$apollo.queries.taxes.refetch();
      }
      this.onResetSave();
      this.taxEditorDialog = false;
      this.selectedTax = {};
      let msg = context == "edit" ? "Tax Updated." : "Tax Created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    },
    onResetSave() {
      this.doSaveTax = false;
    },
    closeDialog() {
      this.taxEditorDialog = false;
      this.selectedTax = {};
    },
    onSaveTax() {
      this.doSaveTax = true;
    },
  },

  apollo: {
    taxes: {
      query: TAXES_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {},
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/currencies/TaxesList.vue